import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as CryptoJS from 'crypto-js';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

let endpoint = 'http://localhost:8080/';
//let endpoint = 'https://solid-gamma-235303.appspot.com/';

//let body = '{ "product":"", "input":"usfob", "calcmt":"original", "frecuency":"month", "datefrom":"2017-01-01", "dateto":"2018-12-31", "origin":"CHILE","destiny":"" }';


@Injectable()
export class AppService {

  constructor(private http: HttpClient) { }
  /* Uses http.get() to load data from a single API endpoint */

  encrypt(data: any) {
    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), 'snbx');
    return ciphertext.toString().replace(/\+/g,'%2B');
  }

  getGraphData(body: any) {
    const encrypted =this.encrypt(body);
    const params = new HttpParams().set('token',encrypted)

    return this.http.get(endpoint, {params});
  }
  getFilterData(country) {
  const params = new HttpParams()
        .set('country',country);
    return this.http.get(endpoint+'filtros',{params});
  }
  getOriginData() {
      return this.http.get(endpoint+'origin');
  }
}
